export const SIDEBAR_VIEW = {
  history: "history",
  preview: "preview",
} as const;

export type SidebarView = (typeof SIDEBAR_VIEW)[keyof typeof SIDEBAR_VIEW];
